import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  HashRouter as Router,
  Route
} from 'react-router-dom';
import App from './components/Main';
import Config from './components/Configuration';

ReactDOM.render((
  <Router>
    <div>
      <Route exact path="/" component={Config} />
      <Route exact path="/:categoryId/:brandId" pageTitle="Dashboard" component={App} />
    </div>
  </Router>
), document.getElementById('app'))


// WEBPACK FOOTER //
// ./src/index.js